import CreateInteraction from "./Create";

export default CreateInteraction;
